var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.859.85l-10.979 11a.51.51 0 01-.359.15H5.49a.463.463 0 01-.348-.15l-4.991-5c-.2-.19-.2-.51 0-.7a.48.48 0 01.698 0l4.661 4.67L16.149.15c.2-.2.509-.2.71 0 .189.19.189.51 0 .7z",
    fill: "#02bd9c"
  })));
}
SvgCheckmark.displayName = 'Checkmark';
export default SvgCheckmark;